import { render, staticRenderFns } from "./AssignReferentCNAToCompanyModal.vue?vue&type=template&id=5f940441&"
import script from "./AssignReferentCNAToCompanyModal.vue?vue&type=script&lang=ts&"
export * from "./AssignReferentCNAToCompanyModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports